module.exports = __webpack_public_path__ + "static/media/07-02.54883ddc.png";